export default "__VITE_ASSET__C0YRu68j__"